<template>
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="cardplay home-card">
        <div class="row dashboard-header g-3 align-items-center mb-4">
          <div class="col-md-8">
            <h2 class="dashboard-title mb-0">Bienvenido{{ userName ? `, ${userName}` : '' }}.</h2>
            <p class="home-subtitle mb-0">Administra, da seguimiento y recupera obligaciones por cobrar desde una sola plataforma.</p>
          </div>
          <div class="col-md-4 text-md-end">
            <span class="home-status">Gestión de obligaciones por cobrar</span>
          </div>
        </div>

        <div class="row g-3">
          <div class="col-lg-8">
            <div class="card-2 home-intro-card">
              <h4 class="home-section-title">¿Qué hace esta plataforma?</h4>
              <p class="home-text mb-3">
                Centraliza la administración de obligaciones por cobrar: registro de compromisos,
                seguimiento de saldos, control de pagos, gestión de cobranza y visualización de indicadores
                para priorizar acciones de recuperación.
              </p>

              <div class="row g-2">
                <div class="col-md-6">
                  <div class="filter-item home-feature">
                    <h6>Control operativo ordenado</h6>
                    <p>Registra obligaciones, clientes y condiciones de pago con trazabilidad en cada etapa.</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="filter-item home-feature">
                    <h6>Seguimiento de cartera</h6>
                    <p>Controla estados, vencimientos, mora y recuperación por sucursal y asesor.</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="filter-item home-feature">
                    <h6>Información para decisiones</h6>
                    <p>Consulta métricas clave para priorizar cobranza, medir desempeño y anticipar riesgo.</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="filter-item home-feature">
                    <h6>Historial y seguimiento</h6>
                    <p>Mantén bitácoras de gestión, actividades y cambios relevantes de cada obligación.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="card home-side-card h-100">
              <div class="card-body">
                <h4 class="home-section-title">Módulos principales</h4>
                <ul class="home-list">
                  <li>Registro y administración de obligaciones.</li>
                  <li>Cartera, pagos y seguimiento de cobranza.</li>
                  <li>Dashboard, indicadores y reportes de recuperación.</li>
                  <li>Bitácora de gestión y configuración operativa.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "./Footer-App.vue";
import { store } from "./store";

export default {
  name: "HomeApp",
  components: {
    Footer,
  },
  data() {
    return {
      store,
    };
  },
  computed: {
    userName() {
      return this.store?.user?.first_name || "";
    },
  },
};
</script>

<style scoped>
.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 32px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.home-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.home-status {
  display: inline-block;
  border: 1px solid #e5e7eb66;
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  color: #f9fafb;
  font-size: 0.85rem;
}

.card-2 {
  border-radius: 16px;
  border: 1px solid #e5eaf0;
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
}

.card {
  border-radius: 16px;
  border: 1px solid #eef2f6;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

.home-section-title {
  color: #111827;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.home-text {
  color: #374151;
  line-height: 1.65;
}

.filter-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px;
}

.home-feature h6 {
  color: #111827;
  font-weight: 700;
  margin-bottom: 0.3rem;
}

.home-feature p {
  margin-bottom: 0;
  color: #4b5563;
  font-size: 0.92rem;
}

.home-side-card {
  background: #ffffff;
}

.home-list {
  margin: 0;
  padding-left: 1.1rem;
}

.home-list li {
  color: #374151;
  margin-bottom: 0.55rem;
}

@media (max-width: 767px) {
  .cardplay {
    padding: 15px;
  }
}

.row > * {
 
    margin-block: 10px !important;
}
</style>
